import { useCallback, useContext } from "react";

import { UserResponse } from "../../interfaces/UserData";
import { UserResultContext } from './user-context';


export const useUserResult = () => {
  const { userResult, setUserResult } = useContext(UserResultContext);

  const createUserResult = useCallback(
    (newUser: UserResponse | undefined): void => {
      setUserResult(newUser);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [userResult]
  );

  const deleteUserResult = useCallback((): void => {
    setUserResult(undefined);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userResult]);

  return {
    userResult,
    createUserResult,
    deleteUserResult,
  };
};
